<div class="container mt-5 pt-2 mb-5">
    <div class="row">
        <div class="col-12 col-md-6">
            <div class="mt-3">
                <input type="text" class="form-control" placeholder="Search here"
                    style="background-color: transparent !important" [(ngModel)]="searchNotice">
            </div>
        </div>
        <div class="col-5 col-md-3">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sort by Urgency</mat-label>
                <mat-select [(ngModel)]="filterUrgency" (ngModelChange)="filterNotice('urgency')">
                    <mat-option value="10">All</mat-option>
                    <mat-option value="0">Not Urgent</mat-option>
                    <mat-option value="1">Urgent</mat-option>
                    <mat-option value="2">Very Urgent</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-7 col-md-3">
            <div class="d-flex mt-3">
                <div class="d-flex ml-2">
                    <div class="size very_urgent mt-1"></div>
                    <i class="text text-muted ml-1">Very Urgent</i>
                </div>
                <div class="d-flex ml-2">
                    <div class="size urgent mt-1"></div>
                    <i class="text text-muted ml-1">Urgent</i>
                </div>
                <div class="d-flex ml-2">
                    <div class="size not_urgent mt-1"></div>
                    <i class="text text-muted ml-1">Not Urgent</i>
                </div>
            </div>
        </div>
    </div>
    <div align="center" *ngIf="spinner" class="mt-5">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>

    <div class="text-center text-danger mt-5" *ngIf="empty">
        <p>{{message}}</p>
    </div>
    <div class="row mt-3" style="height: 70vh; max-height: 75vh;">
        <div class="col-12 mx-auto">
            <mat-accordion>
                <mat-expansion-panel class="mb-2" *ngFor="let notice of filteredNoticeArr | noticeFilter:searchNotice">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="row w-100">
                                <div class="col-10 col-md-10">
                                    <h6 class="mt-3 mt-md-2">
                                        {{notice.notice_title}}
                                    </h6>
                                </div>
                                <div class="col-2 col-md-1">
                                    <div class="mt-4 mt-md-3">
                                        <div class="size not_urgent" *ngIf="notice.notice_urgency == 0"></div>
                                        <div class="size urgent" *ngIf="notice.notice_urgency == 1"></div>
                                        <div class="size very_urgent" *ngIf="notice.noitce_urgency == 2"></div>
                                    </div>
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p [innerHTML]="notice.notice_content" class="p-2"></p>

                    <div class="row">
                        <div class="col-12 col-md-7"></div>
                        <div class="col-6 col-md-3">
                            <i class="text text-muted">Created_at: {{notice.created_at}}</i>
                        </div>

                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>